export const FILTER_NAMES = {
  DEPARTURE_DATE: 'departureDate',
  STATUSES: 'statuses',
  ORDERS: 'orders',
  TYPES: 'types',
  MAIL_GROUPS: 'mailGroups',
  TAGS: 'tags',
  MANAGERS: 'managers',
  ORDER_STATUSES: 'orderStatuses',
  CLOSE_REASON_STATUSES: 'closeReasonStatuses',
  SORT: 'ticketsSort',
} as const;

export const FILTER_TABS = {
  ACTUAL: 'actual',
  PLANNED: 'planned',
} as const;

export const CLOSED_REASON_STATUSES = [
  { value: 'none', title: 'Без причины' },
  { value: 'success', title: 'Подобран' },
  { value: 'bad', title: 'Не подобран' },
  { value: 'auto', title: 'Тайм-аут' },
];

export const TICKET_PLURALIZE = ['тикет', 'тикета', 'тикетов'];

export const FILTER_PLURALIZE = ['Фильтр', 'Фильтра', 'Фильтров'];
